import { useCallback } from 'react';
import { useApp } from '../context/appContext';
import { t } from './index';

/** `const t = useT();  t('log.title')` — bound to the current console locale. */
export function useT() {
  const { locale } = useApp();
  return useCallback((key: string, data?: Record<string, unknown>) => t(key, data, locale), [locale]);
}
